import React from "react";
import { Link, Outlet, useLoaderData } from "react-router-dom";
import { OnboardingSetup } from "./components/OnboardingSetup";
import instance from "../../../axios/instance";
import { getToken } from "../../../utils/token";

export const earningsLoader = async () => {
  const token = getToken();
  const facility = await instance.get("/doctor/facility", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return { facility: facility.data };
};

export const EarningsPage = () => {
  const { facility } = useLoaderData();

  if (!facility.routing_number) {
    return <OnboardingSetup facility={facility} />;
  }

  const tabs = [
    {
      id: 0,
      title: "Overview",
      href: `/dashboard/earnings`,
    },
    {
      id: 1,
      title: "Payments",
      href: `/dashboard/earnings/payments`,
    },
    {
      id: 2,
      title: "Payouts",
      href: `/dashboard/earnings/payouts`,
    },
    {
      id: 3,
      title: "Subscriptions",
      href: `/dashboard/earnings/subscriptions`,
    },
    {
      id: 4,
      title: "Customers",
      href: `/dashboard/earnings/customers`,
    },
  ];

  return (
    <div className="w-full pb-5 bg-bg">
      <div className="bg-[#fafafa] px-7 py-5">
        <p className="font-bold text-2xl">Earnings</p>

        <div className="flex items-center gap-x-5 mt-5 bg-white -mx-7 px-7 py-4 border-t border-b">
          {tabs.map((item) => (
            <Link
              to={item.href}
              key={item.id}
              className={`${
                location.pathname === `/clinic${item.href}`
                  ? "text-primary"
                  : " text-black"
              } inline-block hover:text-primary duration-150 transition-all`}
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
      <div className="px-7">
        <Outlet />
      </div>
    </div>
  );
};
